// src/components/ui/FloatingCartButton.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CartContext } from '../../contexts/CartContext';
import casierIcon from '../../assets/icone_bdc_48.png'; // ✨ PNG optimisé (916 octets)
import '../../styles/cart-icon.css';

const FloatingCartButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getTotalItems, calculateTotal, MINIMUM_ORDER_AMOUNT } = React.useContext(CartContext);
  
  const [animate, setAnimate] = useState(false);
  const [previousCount, setPreviousCount] = useState(0);
  
  const totalItems = getTotalItems();
  const totalAmount = calculateTotal();
  
  // Pages où le bouton floating ne doit PAS s'afficher
  const hiddenPages = ['/cart', '/order', '/delivery'];
  const shouldHide = hiddenPages.some(page => location.pathname.includes(page));
  
  // Animation quand le nombre d'articles change
  useEffect(() => {
    if (totalItems > previousCount) {
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 600);
      return () => clearTimeout(timer);
    }
    setPreviousCount(totalItems);
  }, [totalItems, previousCount]);
  
  const handleClick = () => {
    navigate('/cart');
  };
  
  // Ne pas afficher le bouton sur les pages spécifiées
  if (shouldHide) return null;
  
  // Ne pas afficher si le panier est vide
  if (totalItems === 0) return null;
  
  return (
    <button 
      className={`floating-cart-button ${animate ? 'floating-cart-animate' : ''}`}
      onClick={handleClick}
      aria-label={`Voir le casier - ${totalItems} article${totalItems > 1 ? 's' : ''}`}
    >
      <div className="floating-cart-content">
        {/* Icône casier PNG optimisé */}
        <div className="floating-cart-icon">
          <img 
            src={casierIcon} 
            alt="Casier" 
            className="floating-cart-icon-image"
          />
          
          {/* Badge avec le nombre */}
          <span className="floating-cart-badge">
            {totalItems > 99 ? '99+' : totalItems}
          </span>
        </div>
        
        {/* Texte et montant */}
        <div className="floating-cart-text">
          <span className="floating-cart-label">Voir casier</span>
          <span className="floating-cart-amount">
            {totalAmount.toLocaleString('fr-FR')} FCFA
          </span>
          {totalAmount < MINIMUM_ORDER_AMOUNT && (
            <span className="floating-cart-minimum">
              Min. {MINIMUM_ORDER_AMOUNT.toLocaleString('fr-FR')} FCFA
            </span>
          )}
        </div>
      </div>
    </button>
  );
};

export default FloatingCartButton;